import Header from "../components/Header";
import { Player } from "@lottiefiles/react-lottie-player";

export default function AboutUs() {
  return (
    <>
      <div
        className="bg-[#F8F9FA ] h-350 md:h-160 w-[100%] mt-2
    sm:mt-4
    md:mt-5
    lg:mt-6
    xl:mt-8
    "
      >
        <div className="flex justify-center font-roboto ">
          <section id="about">
            <span className="text-white bg-[#B20925] px-6 py-1 rounded-lg">
              About Us
            </span>
          </section>
        </div>

        <div
          className="mt-2 text-center
           sm:mt-3
           md:mt-4
           lg:mt-4
           xl:mt-4
           "
        >
          <span
            className="text-lg font-bold font-roboto
                  sm:text-xl
                  lg-text-5xl
                  md:text-4xl
                  xl:text-6xl
                 "
          >
            Who We Are
          </span>

          <span
            className="block text-lg font-bold font-roboto
                  sm:text-xl
                  lg-text-5xl
                  md:text-4xl
                  xl:text-6xl
                  "
          >
            Why We Build
          </span>
        </div>

        <div
          className="mt-1 text-center font-roboto text-[#A3A3A3] font-medium
          sm:mt-3 px-1
          md:mt-5 px-2 
          "
        >
          <p className="">
            Our mission is to simplify technology and amplify results.
          </p>
          <p className="">
            With every project, we promise reliability, usability, and
            innovation
          </p>
        </div>

        <div
          className="flex flex-col gap-y-4 m-1 sm:flex-col 
                  custom:flex-wrap custom:flex-row custom:justify-center custom:gap-x-2 md:flex-row md:gap-x-2 md:justify-center"
        >
          {/*Card 1 */}

          <div
            className="relative bg-[#B20925] w-[100%] h-[100%] custom:w-1/2  md:w-[400px] md:h-100 shadow-lg border-x border-gray-200 rounded-lg pt-[54.5px] 
              "
          >
            <img
              src="AboutUs Card.svg"
              alt="About Us"
              className="pt-2 pr-1 pl-1 h-[100%] w-[100%] md:pl-0 md:pt-0 md:pr-0 md:pb-0 md:w-full md:h-full object-contain rounded-lg "
            ></img>

            <div className="absolute top-1 left-15 md:left-[5%] lg:top-2 lg:left-20 text-center text-white font-roboto font-bold text-xl tracking-wide mt-6">
              <p>Driving business growth</p>

              <p>through innovative tech</p>
            </div>

            <div
              className="absolute [top:189px] [left:150px]
                       lg:[top:179px] lg:[left:190px]
                       md:left-[30%]
                      "
            >
              <Player
                autoplay
                loop
                src="Rocket.json" // place this file in public folder or import it
                className="w-26 h-26"
              />
            </div>
          </div>

          {/*Card 2 */}

          <div
            className="  bg-[#FFFFFF] w-[100%] h-[100%] custom:w-1/2  md:w-[400px] md:h-100 shadow-lg border-x border-gray-200 rounded-lg
              
              "
          >
            <div className=" md:p-0 text-center font-roboto  tracking-wide mt-6">
              <p className="md:m-0 text-[#B20925] font-bold text-xl">
                Creating Scalable Digital Futures
              </p>

              <p className="mt-1 px-8 text-sm text-[#A3A3A3] md:mt-2 md:px-0 leading-relaxed  ">
                Our approach blends innovation, agility, and intelligence to{" "}
                <br /> create intuitive, scalable, impactful solutions
              </p>
            </div>

            <div className="relative md:w-[70%] lg:w-[250px] lg:w-full flex justify-center items-center">
              <img className=" lg:static md:absolute md:top-[35%] md:left-[25%] lg:top-[0%] lg:left-[0%]" src="Most Awaited Circle.jpg" />
            </div>
          </div>

          {/*Card 3 */}

          <div
            className="  bg-[#FFFFFF] w-[100%] h-[100%] custom:w-1/2  md:w-[400px] md:h-100 shadow-lg border-x border-gray-200 rounded-lg
              "
          >
            <div className="  text-center font-roboto  tracking-wide mt-6">
              <p className="text-[#B20925] font-bold text-xl">
                Delivering Reliable, Future Ready Solutions
              </p>

              <p className="px-10 text-sm text-[#A3A3A3] mt-2 leading-relaxed md:px-0  ">
                We promise usability, trust, and innovation to keep you <br />{" "}
                ahead in a digital world
              </p>
            </div>

            <div className="relative bg-[#FFFFFF] h-[270px] md:h-60 mx-2 mt-1 mx-1 ">
              <div className="relative">
                <div className="absolute top-5 left-4 md:top-[8%] md:left-4 rotate-347 w-41 h-6  ">
                  <span
                    className="text-[12px] font-roboto text-[#A3A3A3] bg-[#FFFFFF] rounded-md px-2 py-3 "
                    style={{
                      boxShadow: "0 10px 15px rgba(0, 0, 0, 0.25)", // X Y blur color
                    }}
                  >
                    Enduring Innovation
                  </span>
                </div>

                <div className="absolute top-13 left-13 md:top-8 md:left-15 ">
                  <img
                    src="Polygon 8.png"
                    alt="Triangle"
                    className="w-6 h-6 object-contain rotate-[360deg]"
                    style={{
                      filter: "drop-shadow(0px 12px 7px rgba(0,0,0,0.25))",
                    }}
                  ></img>
                </div>
              </div>

              <div className="absolute top-13 md:top-[22%] right-[10%] md:left-[-9%] lg:left-[14%]  bg-[#FFFFFF] h-40 w-65 rotate-347 rounded-lg shadow-xl">
                <div className="relative flex justify-center">
                  <div className=" absolute top-2 inline-flex items-center gap-1 ">
                    <span className="font-roboto font-[#585455]  ">
                      Performances Metrics
                    </span>

                    <img src="Performance.png" className=""></img>
                  </div>

                  <div className="absolute top-13 font-roboto">
                    <span className="text-[#82091D] text-5xl font-semibold">
                      24/7
                    </span>
                  </div>

                  <div className="absolute top-30 inline-flex items-center gap-1">
                    <img src="Group 73.png" className="rotate-10 w-6"></img>

                    <span className="font-roboto font-[#585455]">
                      Support Availability
                    </span>
                  </div>
                </div>
              </div>

              {/*Card 3 Arrow Div */}

              <div className="absolute top-46 left-4 rounded-full w-12 h-12 bg-[#B20925]  border-2 border-white ring ring-white ring-offset-2 ring-offset-[#B20925]">
                <Player
                  autoplay
                  loop
                  src="Arrow.json" // place this file in public folder or import it
                  className=" w-9 h-9"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
